import {
  ChangeDetectionStrategy,
  Component,
  input,
  output,
} from '@angular/core';
import { IconComponent } from '@ui';

@Component({
  selector: 'ui-toggle-button',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [IconComponent],
  template: `
    <button
      (click)="emitToggle()"
      class="flex justify-center items-center rounded-full border border-[#E5E7EB] bg-white text-gray-600 w-6 h-6 translate-x-1/2"
    >
      <ui-icon
        [icon]="!hidden() ? 'caret-left' : 'caret-right'"
        class="text-[10px]"
      />
    </button>
  `,
})
export class ToggleButtonComponent {
  hidden = input<boolean>(false);
  onToggle = output<void>();

  emitToggle() {
    this.onToggle.emit();
  }
}
